import { Link } from "react-router-dom";
import { ChartBar, ArrowRight, CheckCircle, WarningCircle } from "@phosphor-icons/react";

const MAIN_LIFTS = [
  { key: "squat_1rm_lb", label: "Squat" },
  { key: "bench_1rm_lb", label: "Bench" },
  { key: "deadlift_1rm_lb", label: "Deadlift" },
  { key: "ohp_1rm_lb", label: "OHP" },
];

export default function AssessmentStatus({ assessment }) {
  // null = still loading
  if (assessment === null) return null;

  const filled = MAIN_LIFTS.filter((l) => assessment[l.key] != null);
  const hasAny = filled.length > 0;
  const hasAll = filled.length === MAIN_LIFTS.length;

  if (hasAll) {
    return (
      <div
        className="border border-volt bg-volt/10 p-4 mb-6 flex flex-wrap items-center gap-x-6 gap-y-2"
        data-testid="assessment-status-complete"
      >
        <div className="flex items-center gap-2">
          <CheckCircle size={18} weight="bold" className="text-volt" />
          <span className="label-mono text-volt">// ASSESSMENT LOCKED IN</span>
        </div>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
          {MAIN_LIFTS.map((l) => (
            <span key={l.key} className="font-display">
              <span className="text-muted-foreground">{l.label}: </span>
              <span className="font-bold">{Math.round(assessment[l.key])} lb</span>
            </span>
          ))}
        </div>
        <Link
          to="/assessment"
          className="ml-auto label-mono hover:text-volt"
          data-testid="assessment-status-edit"
        >
          UPDATE →
        </Link>
      </div>
    );
  }

  if (hasAny) {
    return (
      <div
        className="border border-volt/40 bg-card p-4 mb-6 flex flex-wrap items-center gap-3"
        data-testid="assessment-status-partial"
      >
        <ChartBar size={18} weight="bold" className="text-volt" />
        <span className="text-sm">
          <span className="font-display font-bold">{filled.length} of {MAIN_LIFTS.length} main lifts logged.</span>{" "}
          <span className="text-muted-foreground">The AI will use what you have and estimate the rest.</span>
        </span>
        <Link
          to="/assessment"
          className="ml-auto inline-flex items-center gap-1 label-mono hover:text-volt"
          data-testid="assessment-status-finish"
        >
          FINISH ASSESSMENT <ArrowRight size={12} weight="bold" />
        </Link>
      </div>
    );
  }

  return (
    <div
      className="border border-border bg-card p-4 mb-6 flex flex-wrap items-center gap-3"
      data-testid="assessment-status-empty"
    >
      <WarningCircle size={18} weight="bold" className="text-muted-foreground" />
      <span className="text-sm text-muted-foreground">
        <span className="font-display font-bold text-foreground">No assessment on file.</span>{" "}
        The AI will use generic level-based weights. Log your 1RMs for plans tuned to your real numbers.
      </span>
      <Link
        to="/assessment"
        className="ml-auto inline-flex items-center gap-2 bg-volt text-black px-3 py-1.5 font-display uppercase tracking-widest text-xs hover:bg-white"
        data-testid="assessment-status-cta"
      >
        Log Assessment <ArrowRight size={12} weight="bold" />
      </Link>
    </div>
  );
}
